import layer from 'vue-layer-mobile'
import {MessageBox} from 'element-ui'

export const cLog = console.log.bind(console)
export const cError = console.error.bind(console)

const _commonNotice = type => message => {
  layer.toast({
    icon: 'icon-check',
    content: message,
    time: message && message.length > 10 ? 2500 : 2000
  })
}

const tip = _commonNotice('info')
const success = _commonNotice('success')
const warn = _commonNotice('warning')
const error = _commonNotice('error')

/* *********
 提示框
 ********* */
export const nTip = tip
export const nTipFunc = (message) => () => tip(message)
export const nSuccess = success
export const nSuccessFunc = (message) => () => success(message)
export const nWarn = warn
export const nWarnFunc = (message) => () => warn(message)
export const nError = error
export const nErrorFunc = (message) => () => error(message)

export const nAlert = (message) => MessageBox.alert(message)



// WEBPACK FOOTER //
// ./src/utils/notice.js